<template>
  <div class="coursesystem-container">
    <module1 />
    <module2 ref="course2"/>
    <module3 ref="course3"/>
    <module4 ref="course4"/>
    <module5 ref="course5"/>
    <module6 ref="course6"/>
    <module7 ref="course7"/>
  </div>
</template>

<script>
import module1 from "./module1.vue";
import module2 from "./module2.vue";
import module3 from "./module3.vue";
import module4 from "./module4.vue";
import module5 from "./module5.vue";
import module6 from "./module6.vue";
import module7 from "./module7.vue";
import {EventBus} from "@/utils/bus";
import {handleScrollToForm} from "@/utils/scrollUtils";
export default {
  name: "CourseSystemPage",
  components: {
    module1,
    module2,
    module3,
    module4,
    module5,
    module6,
    module7,
  },data(){
        return{
            scrollTimeout: null
        }
    }
    ,methods:{

    },mounted() {
        EventBus.$on('scroll-to-course', (sectionId) => handleScrollToForm(this,sectionId))
        if(this.$route.query.section){
            handleScrollToForm(this,this.$route.query.section);
        }
    },
    beforeDestroy() {
        // 移除监听器防止内存泄漏
        EventBus.$off('scroll-to-course', handleScrollToForm)

    }
};
</script>

<style scoped>
.coursesystem-container {
  display: flex;
  flex-direction: column;
}
</style>
